import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from "./plugins/i18n";
import loadScript from "vue-plugin-load-script"
Vue.use(loadScript)

Vue.config.productionTip = false


require("./plugins/filters.js")
Vue.use(loadScript)

import InputFacade from 'vue-input-facade'
Vue.use(InputFacade)

new Vue({
  router,
  store,
  vuetify,
  i18n,

  render: h => h(App)
}).$mount('#application')
